<div class="container mx-auto px-4 py-6">
  <div class="mb-6">
    <div class="flex items-center justify-between mb-4">
      <div>
        <h1 class="text-3xl font-bold text-gray-800">👥 Fornecedores Admin</h1>
        <p class="text-gray-600 mt-1">CRM com filtros inteligentes e controle de planos</p>
      </div>
      <a routerLink="/admin/fornecedores/new" class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">+
        Novo Fornecedor</a>
    </div>

    <!-- Estatísticas rápidas -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <div class="text-2xl font-bold text-blue-900">{{ total }}</div>
        <div class="text-xs text-blue-700">Fornecedores encontrados</div>
      </div>
      <div class="bg-green-50 border border-green-200 rounded-lg p-3">
        <div class="text-2xl font-bold text-green-900">{{ countAtivos() }}</div>
        <div class="text-xs text-green-700">Ativos nesta página</div>
      </div>
      <div class="bg-amber-50 border border-amber-200 rounded-lg p-3">
        <div class="text-2xl font-bold text-amber-900">{{ countDestaque() }}</div>
        <div class="text-xs text-amber-700">Com destaque</div>
      </div>
      <div class="bg-purple-50 border border-purple-200 rounded-lg p-3">
        <div class="text-2xl font-bold text-purple-900">{{ countZumbi() }}</div>
        <div class="text-xs text-purple-700">Zumbis (bloqueados)</div>
      </div>
    </div>
  </div>

  <div class="bg-white rounded-lg shadow p-6 mb-6">
    <h2 class="text-lg font-semibold mb-4">Filtros Avançados</h2>

    <!-- Linha 1: Busca e Filtros Principais -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Nome</label>
        <input [(ngModel)]="nome" type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Buscar por nome">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Categoria</label>
        <select [(ngModel)]="categoria"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Todas as categorias</option>
          <option *ngFor="let c of categorias" [value]="c.slug || c.id">{{ c.nome }}</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
        <select *ngIf="cidades.length > 0" [(ngModel)]="cidadeId"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Todas as cidades</option>
          <option *ngFor="let c of cidades" [value]="c.id">{{ c.nome }} ({{ c.estado }})</option>
        </select>
        <input *ngIf="cidades.length === 0" [(ngModel)]="cidade" type="text"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Ex: Piracicaba">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Plano</label>
        <select [(ngModel)]="plano"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Todos os planos</option>
          <option value="Free">Free</option>
          <option value="Vitrine">Vitrine</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Publicado</label>
        <select [(ngModel)]="publicado"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Todos</option>
          <option value="true">✓ Publicado</option>
          <option value="false">✗ Não Publicado</option>
        </select>
      </div>
    </div>

    <!-- Linha 2: Filtros Avançados -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Destaque</label>
        <select [(ngModel)]="destaque"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Todos</option>
          <option value="true">✓ Com destaque</option>
          <option value="false">✗ Sem destaque</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Ativo</label>
        <select [(ngModel)]="ativo"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Todos</option>
          <option value="true">✓ Ativo</option>
          <option value="false">✗ Inativo</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Claimed</label>
        <select [(ngModel)]="claimed"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Todos</option>
          <option value="true">✓ Claimed</option>
          <option value="false">👻 Não Reivindicado (Shadow)</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Leads Mín. (quentes)</label>
        <input [(ngModel)]="leadsMinimo" type="number" min="0"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Ex: 3">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Vencendo em (dias)</label>
        <input [(ngModel)]="vencendoEmDias" type="number" min="1"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Ex: 30">
      </div>
    </div>

    <!-- Linha 3: Ordenação -->
    <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Ordenar por</label>
        <select [(ngModel)]="orderBy"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="atualizacao">Última atualização</option>
          <option value="nome">Nome (A-Z)</option>
          <option value="leads">Quantidade de leads</option>
          <option value="criacao">Data de criação</option>
        </select>
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Ordem</label>
        <select [(ngModel)]="orderDirection"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="desc">Descendente ↓</option>
          <option value="asc">Ascendente ↑</option>
        </select>
      </div>
      <div class="flex items-end gap-2">
        <button (click)="load()"
          class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition">
          🔍 Filtrar
        </button>
        <button (click)="resetFilters()"
          class="flex-1 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition">
          ✕ Limpar
        </button>
      </div>
    </div>

    <!-- Info de filtros ativos -->
    <div *ngIf="(nome || categoria || cidade || cidadeId || plano || publicado || destaque || ativo || claimed || leadsMinimo || vencendoEmDias)"
      class="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md text-sm text-blue-800">
      📌 Filtros aplicados:
      <span *ngIf="nome">nome="{{nome}}"</span>
      <span *ngIf="categoria"> categoria="{{categoria}}"</span>
      <span *ngIf="cidadeId"> cidadeId="{{cidadeId}}"</span>
      <span *ngIf="!cidadeId && cidade"> cidade="{{cidade}}"</span>
      <span *ngIf="plano"> plano="{{plano}}"</span>
      <span *ngIf="publicado"> publicado={{publicado}}</span>
      <span *ngIf="destaque"> destaque={{destaque}}</span>
      <span *ngIf="ativo"> ativo={{ativo}}</span>
      <span *ngIf="claimed"> claimed={{claimed}}</span>
      <span *ngIf="leadsMinimo"> leadsMinimo≥{{leadsMinimo}}</span>
      <span *ngIf="vencendoEmDias"> vencendo≤{{vencendoEmDias}}dias</span>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <div class="mb-4 p-4 bg-gray-50 border-b">
      <strong>Debug:</strong> {{ items.length }} items carregados, total: {{ total }}
    </div>
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fornecedor</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contato</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Localidade</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Categoria</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Plano / Status
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Leads</th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Destaque</th>
            <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Ativo</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Últimas Mudanças
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let f of items" class="hover:bg-gray-50 transition">
            <td class="px-6 py-4">
              <div class="text-sm font-semibold text-gray-900">{{ f.nome }}</div>
              <div class="text-xs text-gray-500">{{ f.id }}</div>
              <span *ngIf="f.seloFornecedor" class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 mt-1">🏅 Selo</span>
              <span *ngIf="f.isClaimed === false" class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-orange-100 text-orange-800 mt-1">👻 Shadow</span>
              <span *ngIf="f.isClaimed" class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 mt-1">✓ Claimed</span>
            </td>
            <td class="px-6 py-4 text-sm">
              <div *ngIf="f.email" class="text-xs text-gray-700 truncate max-w-[160px]" [title]="f.email">✉️ {{ f.email }}</div>
              <div *ngIf="f.telefone" class="text-xs text-gray-500 mt-0.5">📞 {{ f.telefone }}</div>
            </td>
            <td class="px-6 py-4 text-sm">
              <div class="text-gray-700">{{ getCidadesDisplay(f) }}</div>
              <div *ngIf="f.cidades && f.cidades.length > 0" class="text-xs text-blue-600 mt-0.5">🌆 {{ f.cidades.length }} {{ f.cidades.length === 1 ? 'cidade' : 'cidades' }}</div>
            </td>
            <td class="px-6 py-4 text-sm">
              <span *ngIf="f.categoria"
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                {{ f.categoria.nome }}
              </span>
              <span *ngIf="!f.categoria" class="text-gray-400">—</span>
            </td>
            <td class="px-6 py-4">
              <div class="flex flex-col gap-1">
                <span
                  [ngClass]="f.planLevelText === 'Vitrine' ? 'inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-800' : 'inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-800'">
                  {{ f.planLevelText }}
                </span>
                <span [ngClass]="{
                  'px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800': f.status === 'Ativo',
                  'px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800': f.status === 'Inativo',
                  'px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800': f.status === 'Zumbi'
                }">
                  {{ f.status }}
                </span>
              </div>
            </td>
            <td class="px-6 py-4">
              <div class="text-sm font-semibold text-gray-900">{{ f.leadCount }}</div>
              <div class="text-xs text-gray-500" *ngIf="f.status === 'Zumbi'">📛 Bloqueado</div>
              <div class="text-xs text-blue-600 mt-0.5" *ngIf="f.vitrineSinceDate">Vitrine desde {{ f.vitrineSinceDate | date:'dd/MM/yy' }}</div>
            </td>
            <td class="px-6 py-4 text-center">
              <button (click)="toggleDestaque(f)" class="inline-flex items-center"
                [title]="f.destaque ? 'Remover destaque' : 'Adicionar destaque'">
                <span *ngIf="f.destaque" class="text-2xl">⭐</span>
                <span *ngIf="!f.destaque" class="text-2xl text-gray-300">☆</span>
              </button>
            </td>
            <td class="px-6 py-4 text-center">
              <button (click)="toggleAtivo(f)" class="inline-flex items-center focus:outline-none"
                [title]="f.ativo ? 'Clique para desativar' : 'Clique para ativar'">
                <span *ngIf="f.ativo"
                  class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800 hover:bg-green-200 cursor-pointer">
                  ✓ Ativo
                </span>
                <span *ngIf="!f.ativo"
                  class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-800 hover:bg-gray-200 cursor-pointer">
                  ✗ Inativo
                </span>
              </button>
            </td>
            <td class="px-6 py-4 text-xs text-gray-600">
              {{ (f.updatedAt || f.createdAt) ? ((f.updatedAt || f.createdAt) | date:'dd/MM/yyyy HH:mm') : '—' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-xs font-medium">
              <div class="flex flex-col gap-1">
                <a [routerLink]="['/admin/fornecedores', f.id, 'detail']"
                  class="text-violet-600 hover:text-violet-900 font-semibold">👁️ Detalhes</a>
                <a [routerLink]="['/admin/fornecedores', f.id, 'edit']"
                  class="text-blue-600 hover:text-blue-900 font-semibold">✏️ Editar</a>
                <a [routerLink]="['/admin/term-acceptances']" [queryParams]="{ fornecedorId: f.id }"
                  class="text-green-600 hover:text-green-900 font-semibold" title="Ver Aceites de Termo">📜 Termos</a>
                <a [routerLink]="['/admin/supplier-payments']" [queryParams]="{ fornecedorId: f.id }"
                  class="text-indigo-600 hover:text-indigo-900 font-semibold" title="Ver Pagamentos">💰 Pagamentos</a>
                <button (click)="openOverrideModal(f.id)" class="text-amber-600 hover:text-amber-900">⚡ Plano</button>
                <button (click)="resetLeads(f.id)" class="text-purple-600 hover:text-purple-900">🔄 Reset</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
      <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div>
          <p class="text-sm text-gray-700">
            Mostrando
            <span class="font-semibold text-gray-900">{{ (page - 1) * pageSize + 1 }}</span>
            até
            <span class="font-semibold text-gray-900">{{ displayEnd() }}</span>
            de
            <span class="font-semibold text-gray-900">{{ total }}</span>
            resultado{{ total !== 1 ? 's' : '' }}
          </p>
        </div>
        <div class="flex items-center gap-4">
          <div class="text-xs text-gray-500">
            Página <span class="font-semibold">{{ page }}</span> de <span class="font-semibold">{{ Math.ceil(total /
              pageSize) }}</span>
          </div>
          <app-pagination [page]="page" [pageSize]="pageSize" [total]="total"
            (pageChange)="onPageChange($event)"></app-pagination>
        </div>
      </div>
    </div>
  </div>

  <!-- Plan Override Modal -->
  <div *ngIf="overrideModalOpen" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg mx-4">
      <h2 class="text-xl font-semibold mb-4">⚡ Override de Plano</h2>
      <p class="text-sm text-gray-600 mb-4">Force um novo plano para este fornecedor (útil para permutas, testes, etc.)
      </p>
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Novo Plano</label>
          <select [(ngModel)]="overridePlanLevel"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="Vitrine">💎 Vitrine (destaque)</option>
            <option value="Free">🆓 Free (padrão)</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Data de Expiração (opcional)</label>
          <input [(ngModel)]="overrideExpiryDate" type="date"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <p class="text-xs text-gray-500 mt-1">Se deixar vazio, será permanente até próxima alteração</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Motivo/Observações</label>
          <input [(ngModel)]="overrideReason" type="text"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Ex: Permuta com evento XYZ, Teste de 7 dias, etc.">
        </div>
      </div>
      <div class="mt-6 flex justify-end gap-2">
        <button (click)="closeOverrideModal()"
          class="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">Cancelar</button>
        <button (click)="applyOverride()"
          class="px-4 py-2 bg-amber-600 text-white rounded-md hover:bg-amber-700">Aplicar Override</button>
      </div>
    </div>
  </div>
</div>